import { css } from '@emotion/css';
import { ColorConstant, Font } from 'src/styles';

export const select = css`
  ${Font.lg}
  color: ${ColorConstant.GRAY10};
`;
